export const CONFIRMATION_DIALOG_TYPES = {
    EMPTY_PROJECT: 'EMPTY_PROJECT',
    EMPTY_HOME_PAGE: 'EMPTY_HOME_PAGE',
    NO_REWARDS_BLOCKS: 'NO_REWARDS_BLOCKS',
    CHECK_EMAIL_FOR_REWARDS: 'CHECK_EMAIL_FOR_REWARDS',
}

export const AUTO_SAVE_INTERVAL = 20000
